import { createContext } from 'react';

export interface AsyncPopupContextType {
    onApply: (popupId: string) => void;
    onClose: (popupId: string) => void;
}

export const AsyncPopupContext = createContext<AsyncPopupContextType | null>(null);
